<template>
  <span>
    <!-- <span class="need-money" v-if="needMoney">
      Псс.. Парень, тебе бы накинуть пару шекелей на счёт..
      <router-link :to="{name: 'pay'}">
        <div class="my-btn ml-3" @click="needMoney = false">
            <i class="fa fa-rub"></i>
        </div>
      </router-link>
    </span>-->

    <!-- <navbar :show-navbar="showNavbar" class="bg-info">
      <div class="navbar-wrapper">
        <div class="navbar-minimize">
          <button id="minimizeSidebar" class="btn btn-icon btn-round" @click="minimizeSidebar">
            <i class="nc-icon nc-minimal-right text-center visible-on-sidebar-mini"></i>
            <i class="nc-icon nc-minimal-left text-center visible-on-sidebar-regular"></i>
          </button>
        </div>
        <div class="navbar-toggle">
          <navbar-toggle-button @click.native="toggleSidebar"></navbar-toggle-button>
        </div>
        <a class="navbar-brand" href="#pablo">actid</a>
      </div> -->
      <!--    <template slot="navbar-menu">-->
      <!--&lt;!&ndash;      <form>&ndash;&gt;-->
      <!--&lt;!&ndash;        <div class="input-group no-border">&ndash;&gt;-->
      <!--&lt;!&ndash;          <input type="text" value="" class="form-control" placeholder="Search...">&ndash;&gt;-->
      <!--&lt;!&ndash;          <div class="input-group-append">&ndash;&gt;-->
      <!--&lt;!&ndash;            <div class="input-group-text">&ndash;&gt;-->
      <!--&lt;!&ndash;              <i class="nc-icon nc-zoom-split"></i>&ndash;&gt;-->
      <!--&lt;!&ndash;            </div>&ndash;&gt;-->
      <!--&lt;!&ndash;          </div>&ndash;&gt;-->
      <!--&lt;!&ndash;        </div>&ndash;&gt;-->
      <!--&lt;!&ndash;      </form>&ndash;&gt;-->
      <!--      <ul class="navbar-nav">-->
      <!--        <li class="nav-item">-->
      <!--          <a class="nav-link btn-magnify" href="#pablo">-->
      <!--            <i class="nc-icon nc-layout-11"></i>-->
      <!--            <p>-->
      <!--              <span class="d-lg-none d-md-block">Stats</span>-->
      <!--            </p>-->
      <!--          </a>-->
      <!--        </li>-->
      <!--        <drop-down icon="nc-icon nc-bell-55" tag="li"-->
      <!--                   position="right"-->
      <!--                   direction="none"-->
      <!--                   class="nav-item btn-rotate dropdown">-->
      <!--          <a slot="title"-->
      <!--             slot-scope="{isOpen}"-->
      <!--             class="nav-link dropdown-toggle"-->
      <!--             data-toggle="dropdown"-->
      <!--             aria-haspopup="true"-->
      <!--             :aria-expanded="isOpen">-->
      <!--            <i class="nc-icon nc-bell-55"></i>-->
      <!--            <p>-->
      <!--              <span class="d-lg-none d-md-block">Some Actions</span>-->
      <!--            </p>-->
      <!--          </a>-->
      <!--          <a class="dropdown-item" href="#">Action</a>-->
      <!--          <a class="dropdown-item" href="#">Another action</a>-->
      <!--          <a class="dropdown-item" href="#">Something else here</a>-->
      <!--        </drop-down>-->
      <!--        <li class="nav-item">-->
      <!--          <a class="nav-link btn-rotate" href="#pablo">-->
      <!--            <i class="nc-icon nc-settings-gear-65"></i>-->
      <!--            <p>-->
      <!--              <span class="d-lg-none d-md-block">Account</span>-->
      <!--            </p>-->
      <!--          </a>-->
      <!--        </li>-->
      <!--      </ul>-->
      <!--    </template>-->

      <!--    <div class="container-fluid">-->
      <!--      <div class="row" style=" height: 60px">-->
      <!--        <div class="col deadline"></div>-->
      <!--        <div class="col-auto" style="max-height: 50px">-->
      <!--          <flip-countdown deadline="2019-04-12 12:00:00"></flip-countdown>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--    </div>-->
    </navbar>
  </span>
</template>
<script>
import { Navbar, NavbarToggleButton } from "src/components/UIComponents";

export default {
  components: {
    Navbar,
    NavbarToggleButton
  },
  data() {
    return {
      activeNotifications: false,
      showNavbar: false,

      needMoney: true
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    minimizeSidebar() {
      this.$sidebar.toggleMinimize();
    },
    toggleNavbar() {
      this.showNavbar = !this.showNavbar;
    }
  }
};
</script>
<style>
.navbar {
  height: 62px !important;
  pointer-events: none;
}

.need-money {
  position: absolute;
  background-color: #f0340d;
  height: 62px;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1rem;
}

.my-btn {
  display: inline-block;
  background-color: transparent;
  padding: 3px 12px;
  border: solid 2px black;
  border-radius: 10px;
  font-size: 1.1rem;
  color: black;
}
/*.deadline {*/
/*  background-image: url(/assets/imgNovaPersons/deadLine.png);*/
/*  !*background-size: contain;*!*/
/*  background-size: 9em;*/
/*  background-repeat: no-repeat;*/
/*  background-position: right center;*/
/*}*/
</style>
